import {combineReducers} from '@reduxjs/toolkit';
import seatClasses from './seat-classes.slice';
import createSeatClass from './create-seat-class.slice';
import deleteSeatClass from './delete-seat-class.slice';
import updateSeatClass from './update-seat-class.slice';

const reducer = combineReducers({
  seatClasses,
  createSeatClass,
  deleteSeatClass,
  updateSeatClass
});

export default reducer;
